const links = {
  github: "https://github.com/dameny/",
  linkedIn: "https://www.linkedin.com/in/dameny/",
};

export default links;
